import { Earth } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { PurchaseOrderStatusBadge } from '@/features/purchase-order/components/purchase-order-status-badge';
import { useGetPurchaseOrder } from '@/services/apis/queries/purchase-order/use-get-purchase-order';

type PurchaseOrderLayoutHeaderProps = {
  purchaseOrderId: string;
};

export function PurchaseOrderLayoutHeader({
  purchaseOrderId,
}: PurchaseOrderLayoutHeaderProps) {
  const { t } = useTranslation('purchaseOrder');
  const { data: purchaseOrder } = useGetPurchaseOrder(purchaseOrderId);

  return (
    <div className='flex items-center justify-between gap-4'>
      <h1 className='flex items-center gap-2 font-semibold text-2xl'>
        PO - {purchaseOrder.name}
        {purchaseOrder.isConcernedByProductionDeclaration && (
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                aria-label={t('concernedByEudr')}
                className='inline-flex cursor-help text-green-600'
                type='button'
              >
                <Earth aria-hidden='true' className='size-6' />
              </button>
            </TooltipTrigger>
            <TooltipContent>{t('concernedByEudr')}</TooltipContent>
          </Tooltip>
        )}
      </h1>
      {purchaseOrder.statusCode && (
        <PurchaseOrderStatusBadge
          className='shrink-0 px-6 py-2 text-sm'
          statusCode={purchaseOrder.statusCode}
          withBorder
        />
      )}
    </div>
  );
}
